import type { ComputedRef, Ref } from "vue";
import { FEATURE_NAMES, logError } from "@/loggers";

export type SelectOption = { label: string; value: string | number };

export interface GlobalOptionsProvider {
  options: Ref<SelectOption[]> | ComputedRef<SelectOption[]>;
  fetch: () => Promise<void> | void;
}

const providers = new Map<string, GlobalOptionsProvider>();

export const registerGlobalOptionsProvider = (key: string, provider: GlobalOptionsProvider): void => {
  if (providers.has(key)) {
    logError(
      FEATURE_NAMES.MVS_FILTERS,
      `[globalOptions] provider for key "${key}" was already registered; overwriting.`
    );
  }
  providers.set(key, provider);
};

export const getGlobalOptionsProvider = (key: string): GlobalOptionsProvider | undefined => providers.get(key);

// Test-only escape hatch (not exported from the public barrel).
export const __resetGlobalOptionsRegistry = (): void => {
  providers.clear();
};
